import { FULL_DATE } from '@/constants/dateFormat';
import dayjs from 'dayjs';
import _ from 'lodash';
import * as Yup from 'yup'
import { SUBSCRIBE_OPTION } from '../constants';

export const defaultMakeInfo = {
  option: [],
  remark: '',
  date: dayjs().format(FULL_DATE),
  member_id: null,
}

export const makeSchema = Yup.object({
  date: Yup.string().required('请选择预约时间'),
  option: Yup.array().of(
    Yup.object({
      content: Yup.string().when(['check', 'option_id'], {
        // 只判断三项
        is: (check, option_id) => check && option_id === SUBSCRIBE_OPTION.PARKING,
        then: Yup.string().required('请输入车牌号').min(7, '车牌号至少7位字符').max(8, '车牌号至多8位字符')
      }).when(['check', 'option_id'], {
        // 只判断三项
        is: (check, option_id) => check && [
          SUBSCRIBE_OPTION.SA,
          SUBSCRIBE_OPTION.LOUNGE,
        ].includes(option_id),
        then: Yup.string().required('请选择预约人数')
      }),
      number: Yup.string().when(['check', 'option_id'], {
        is: (check, option_id) => check && [
          SUBSCRIBE_OPTION.SA,
          SUBSCRIBE_OPTION.LOUNGE,
          SUBSCRIBE_OPTION.PARKING
        ].includes(option_id),
        then: Yup.string().required('请选择时间段')
      })
    })
  )
});
